var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductFilter',{attrs:{"isOnProductDetailPage":_vm.isOnProductDetailPage,"placeholderText":_vm.placeholderText,"totalFiltersActive":_vm.totalFiltersActive,"filterType":"tag","title":"Tags","tooltipText":"For example, new or featured"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05767c4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/ProductFilterTags.vue
// module id = d7HT
// module chunks = 1